import React, { useState } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import { EffectFade } from 'swiper/modules'
import { StaticQuery, graphql } from 'gatsby'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import 'swiper/css'
import ButtonBlock from './ButtonBlock'

const VerticalAccordionTemplate = ({ data }) => {
  const [activeIndex, setActiveIndex] = useState(0)
  
  const items = data.allMarkdownRemark.edges.map(edge => ({
    title: edge.node.frontmatter.homeAccordion.title,
    subtitle: edge.node.frontmatter.homeAccordion.subtitle || undefined,
    description: edge.node.frontmatter.homeAccordion.summary,
    image: getImage(edge.node.frontmatter.homeAccordion.image) || getImage(edge.node.frontmatter.image),
    buttonText: "Learn More",
    buttonLink: edge.node.fields.slug,
  }))

  const handleNext = () => {
    setActiveIndex((prev) => (prev + 1) % items.length)
  }

  const handlePrev = () => {
    setActiveIndex((prev) => (prev - 1 + items.length) % items.length)
  }

  const handleColumnClick = (index) => {
    setActiveIndex(index)
  }

  return (
    <div className="vertical-accordion-section">
      <div className="container has-text-centered is-relative">
        <h2 className="section__title is-size-1 is-size-3-mobile is-uppercase mb-2">Meeting Locations</h2>
        <p className='section__desc is-size-5 mb-6'>Hazard County Shuttle is the only bike shuttle company in Moab that offers mountain bike trailhead departures for Mag-7, Porcupine Rim, Raptor Route, and the Whole Enchilada Lower Section.</p>
      </div>
      <div className="vertical-accordion-columns">
        {items.map((item, index) => (
          <div 
            key={index} 
            className={`vertical-accordion-column ${activeIndex === index ? 'active' : ''}`}
            data-index={index}
            onClick={() => handleColumnClick(index)}
          >
            <div className="column-background">
              <GatsbyImage
                image={item.image}
                alt={item.title}
                objectPosition={item.buttonLink === '/meeting-locations/rim-cyclery-bike-shop/' ? 'left center' : 'center center'}
                className="gatsby-image-background"
              />
              <div className="column-overlay"></div>
            </div>
            <div className="column-title">{item.title}</div>
            <div className="column-content">
              <div className="content-inner">
                <div>
                  {item.subtitle && (
                    <h2 className='is-size-3'>{item.subtitle}</h2>
                  )}
                  <p>{item.description}</p>
                </div>
                <ButtonBlock
                  link={item.buttonLink}
                  text={item.buttonText}
                />
              </div>
            </div>
          </div>
        ))}
      </div>
      <div className="vertical-accordion-arrows slider-arrows">
        <button className="slider-arrow prev" onClick={handlePrev}>
          <div className="slider__arrow-wrapper">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g opacity="0.8">
                <path d="M25.334 16H6.66732" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"></path>
                <path d="M16 6.66663L6.66667 16L16 25.3333" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"></path>
              </g>
            </svg>
          </div>
        </button>
        <button className="slider-arrow next" onClick={handleNext}>
          <div className="slider__arrow-wrapper">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g opacity="0.8">
                <path d="M6.66602 16H25.3327" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"></path>
                <path d="M16 6.66663L25.3333 16L16 25.3333" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"></path>
              </g>
            </svg>
          </div>
        </button>
      </div>
      <div className="content">
        <div className="vertical-accordion-mobile">
          <Swiper
            slidesPerView={1}
            spaceBetween={16}
            effect="slide"
            speed={800}
            modules={[EffectFade]}
            className="accordion-mobile"
          >
            {items.map((item, index) => (
              <SwiperSlide key={index}>
                <div className="mobile-slide">
                  <div className="mobile-slide__image">
                    {item.image && (
                      <GatsbyImage height={450} width={800} image={item.image} alt={item.title} style={{
                        width: "100%",
                        height: "100%",
                        aspectRatio: "800/450",
                      }} />
                    )}
                    <a className="mobile-slide__button" href={item.buttonLink}>
                      <svg width="100%" height="100%" viewBox="0 0 88 88" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0 0H44H66L88 22V44V88H44H22L0 66V44V0Z" fill="black" fillOpacity="0.4"></path>
                        <path d="M0.5 0.5H44H65.7929L87.5 22.2071V44V87.5H44H22.2071L0.5 65.7929V44V0.5Z" stroke="white" strokeOpacity="0.13"></path>
                      </svg>
                      <svg className="mobile-slide__arrow" width="63" height="64" viewBox="0 0 63 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M22.0391 41.0745L40.1881 22.9254" stroke="#F5F5F5" strokeWidth="2.45997" strokeLinecap="round" strokeLinejoin="round"></path>
                        <path d="M22.0391 22.9255H40.1881V41.0746" stroke="#F5F5F5" strokeWidth="2.45997" strokeLinecap="round" strokeLinejoin="round"></path>
                      </svg>
                    </a>
                  </div>
                  <div className="mobile-slide__content">
                    {/* <h3 className="mobile-slide__title">{item.title}</h3> */}
                    {/* <h3 className="mobile-slide__title is-size-6">{item.subtitle}</h3> */}
                    {item.subtitle && (
                      <h3 className="mobile-slide__title is-size-6 mt-0 mb-1">{item.subtitle}</h3>
                    )}
                    <p className="mobile-slide__desc">{item.description}</p>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </div>
  )
}

const VerticalAccordion = () => (
  <StaticQuery
    query={graphql`
      query VerticalAccordionQuery {
        allMarkdownRemark(
          filter: { frontmatter: { templateKey: { eq: "departure-locations-post" } } }
          sort: { frontmatter: { meta: { sortOrder: ASC } } }
        ) {
          edges {
            node {
              id
              fields {
                slug
              }
              frontmatter {
                title
                subtitle
                summary
                homeAccordion {
                  title
                  subtitle
                  summary
                  image {
                    childImageSharp {
                      gatsbyImageData(
                        quality: 100
                        placeholder: BLURRED
                      )
                    }
                  }
                }
                image {
                  childImageSharp {
                    gatsbyImageData(
                      quality: 100
                      width: 800
                      height: 450
                      layout: CONSTRAINED
                      transformOptions: {
                        fit: COVER
                        cropFocus: ATTENTION
                      }
                      placeholder: BLURRED
                    )
                  }
                }
                meta {
                  showTitle
                }
              }
            }
          }
        }
      }
    `}
    render={data => <VerticalAccordionTemplate data={data} />}
  />
)

export default VerticalAccordion
